import React from 'react'

export const DataNotFound = ({message}) => {
    return (
        <div className="no-data-found text-center">
            <img src="/images/no-data-found.png" alt="" />
            <p className="text-center">{message}</p>
        </div>
    )
}
